import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./providers/AuthProvider";
import AppInitializer from "./AppInitializer";
import RoutesApp from "./routing/routes";
import AppTheme from "../shared/theme/AppTheme";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <AuthProvider>
      <AppInitializer>
        <AppTheme>
          <Toaster
            reverseOrder
            toastOptions={{
              position: "bottom-left",
              style: { maxWidth: "100vw" },
              duration: 5000,
            }}
          />

          {/* v7_startTransition: navegação para rota lazy mantém a tela
              atual visível enquanto o chunk carrega, em vez de suspender
              a árvore e piscar o fallback. */}
          <BrowserRouter future={{ v7_startTransition: true }}>
            <RoutesApp />
          </BrowserRouter>
        </AppTheme>
      </AppInitializer>
    </AuthProvider>
  );
}

export default App;